<template>
    <div class="" ref="box" v-if="sendVal.copyright">
        <span class="my-uname" ref='box1'>{{sendVal.txt}}</span>
    </div>
    <div v-else class="my-uname" ref='box1'>{{sendVal.txt}}</div>
</template>

<script>
export default {
    name: 'my-marquee-left',
    props: {
        sendVal: Object
    },
    data () {
        return {
        }
    },
    mounted () {
        this.$refs.box1.style.fontSize = this.sendVal.fontSize
        this.$refs.box1.style.color = this.sendVal.color
        this.$refs.box1.style.opacity = this.sendVal.opacity;
    },
}
</script>

<style lang="scss" scoped>
.box{
    position: relative;
    height: 30px;
    line-height: 30px;
    margin: 10px;
    overflow: hidden;
    background-color: #ccc;
    .my-uname{
        position: absolute;
        width: fit-content;
        white-space: nowrap;
        transform: translate(408px,50%);
        left: 0;
        top: -50%;
        animation: moveunique1 50s linear infinite;
    }
}
.my-uname{
    position: absolute;
    width: fit-content;
    white-space: nowrap;
    transform: translateX(408px);
    left: 0;
    top: 100px;
    animation: moveunique 50s linear infinite;
}
@keyframes moveunique {
    0% {
        transform: translateX(408px);
    }

    40% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(-100%);
    }
}
@keyframes moveunique1 {
    0% {
        transform: translate(408px,50%);
    }

    40% {
        transform: translate(-100%,50%);
    }
    100% {
        transform: translate(-100%,50%);
    }
}
</style>
